var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSolicitation1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.768 19.911",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 291"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 282"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#293778",
    stroke: "#293778",
    strokeWidth: 0.5,
    d: "M17.425 4.426a9.353 9.353 0 0 1 1.69 4.079h-1.644a7.809 7.809 0 0 0-1.211-2.914l1.164-1.165m.033-.492-1.622 1.622a7.413 7.413 0 0 1 1.361 3.274h2.289a9.685 9.685 0 0 0-2.028-4.9Z",
    "data-name": "Caminho 264"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 283"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#293778",
    stroke: "#293778",
    strokeWidth: 0.5,
    d: "M11.283.671a9.364 9.364 0 0 1 4.078 1.69l-1.166 1.165a7.787 7.787 0 0 0-2.913-1.211V.671m-.324-.372v2.289a7.426 7.426 0 0 1 3.274 1.361l1.622-1.622a9.688 9.688 0 0 0-4.9-2.028Z",
    "data-name": "Caminho 265"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 284"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#293778",
    stroke: "#293778",
    strokeWidth: 0.5,
    d: "M19.115 11.425a9.349 9.349 0 0 1-1.69 4.078l-1.165-1.165a7.792 7.792 0 0 0 1.211-2.913h1.644m.372-.324h-2.289a7.421 7.421 0 0 1-1.361 3.274l1.622 1.622a9.688 9.688 0 0 0 2.028-4.9Z",
    "data-name": "Caminho 266"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 285"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#293778",
    stroke: "#293778",
    strokeWidth: 0.5,
    d: "m14.194 16.403 1.166 1.166a9.361 9.361 0 0 1-4.078 1.69v-1.644a7.8 7.8 0 0 0 2.913-1.212m.036-.423a7.413 7.413 0 0 1-3.274 1.361v2.289a9.688 9.688 0 0 0 4.9-2.028l-1.622-1.622Z",
    "data-name": "Caminho 267"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 286"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#293778",
    stroke: "#293778",
    strokeWidth: 0.5,
    d: "M5.412 15.98 3.79 17.602a9.687 9.687 0 0 0 4.9 2.028v-2.289a7.417 7.417 0 0 1-3.274-1.361Z",
    "data-name": "Caminho 268"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 287"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#293778",
    stroke: "#293778",
    strokeWidth: 0.5,
    d: "m2.308 15.978 1.622-1.622a7.415 7.415 0 0 1-1.361-3.274H.28a9.685 9.685 0 0 0 2.028 4.9Z",
    "data-name": "Caminho 269"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 288"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#293778",
    stroke: "#293778",
    strokeWidth: 0.5,
    d: "M.281 8.811H2.57a7.42 7.42 0 0 1 1.361-3.274L2.308 3.915a9.686 9.686 0 0 0-2.028 4.9Z",
    "data-name": "Caminho 270"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 289"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#293778",
    stroke: "#293778",
    strokeWidth: 0.5,
    d: "M5.537 3.931A7.413 7.413 0 0 1 8.811 2.57V.281a9.685 9.685 0 0 0-4.9 2.028l1.622 1.622Z",
    "data-name": "Caminho 271"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSolicitation1);
export default __webpack_public_path__ + "static/media/icon-solicitation-1.e526f5462a41208f4b2b7fd1bc1b41d7.svg";
export { ForwardRef as ReactComponent };